import { render, staticRenderFns } from "./UNICOCHECK.vue?vue&type=template&id=159e02a0"
import script from "./UNICOCHECK.vue?vue&type=script&lang=js"
export * from "./UNICOCHECK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports